import { createElement } from 'react';

import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import IconTITV from '@components/Images/IconTITV';
import { IMGIX_URL } from '@src/env';

import { CompanyLogo } from '../OfferSelection/TheInformationPro/Companies';

export const BENEFITS = [
  { name: 'All of our award-winning journalism', eligibility: [true, true, true] },
  {
    name: createElement(IconDeepResearchText, { className: 'deep-research-logo' }),
    eligibility: [false, false, true],
  },
  { name: '6+ informative newsletters', eligibility: [true, true, true] },
  { name: 'Access to community networking tools', eligibility: [true, true, true] },
  { name: 'Read on the go with The Information app', eligibility: [true, true, true] },
  { name: 'Library of 52+ company org charts', eligibility: [false, false, true] },
  { name: 'Frequently updated funding databases', eligibility: [false, false, true] },
  { name: 'Exclusive Pro newsletter', eligibility: [false, false, true] },
  { name: 'Access to subscriber survey results', eligibility: [false, false, true] },
];

export const BENEFITS_GIFT_LANDING = [
  { name: 'All of our award-winning journalism', eligibility: [true, true] },
  { name: '6+ informative newsletters', eligibility: [true, true] },
  { name: 'Access to community networking tools', eligibility: [true, true] },
  { name: 'Read on the go with The Information app', eligibility: [true, true] },
  {
    name: createElement(
      'div',
      { className: 'flex items-center gap-8' },
      createElement(IconTITV, {
        className: 'titv-logo w-[22px] text-primary-magenta',
      }),
      createElement(
        'span',
        { className: 'font-suisse-intl text-overline-md ' },
        "The Information's TITV"
      )
    ),
    eligibility: [true, true],
  },
  {
    name: createElement(IconDeepResearchText, { className: 'deep-research-logo' }),
    eligibility: [false, true],
  },
  { name: 'Library of 70+ company org charts', eligibility: [false, true] },
  { name: 'Exclusive AI Databases & Trackers', eligibility: [false, true] },
  { name: 'Exclusive Pro newsletter', eligibility: [false, true] },
  { name: 'Access to subscriber survey results', eligibility: [false, true] },
];

export const companies: CompanyLogo[] = [
  {
    name: 'Apple',
    className: 'h-[25px] w-[20px] sm:h-[28px] sm:w-[23px]',
    path: `${IMGIX_URL}/global/subscribe/Apple_White_Logo.png`,
  },
  {
    name: 'Google',
    className: 'h-[19px] w-[56px] sm:h-[22px] sm:w-[65px]',
    path: `${IMGIX_URL}/global/subscribe/Google_White_Logo.png`,
  },
  {
    name: 'Microsoft',
    className: 'h-[20px] w-[93px] sm:h-[23px] sm:w-[107px]',
    path: `${IMGIX_URL}/global/subscribe/Microsoft_White_Logo.png`,
  },
  {
    name: 'Meta',
    className: 'h-[12px] w-[59px] sm:h-[15px] sm:w-[74px]',
    path: `${IMGIX_URL}/global/subscribe/Meta_White_Logo.png`,
  },
  {
    name: 'Nvidia',
    className: 'h-[16px] w-[87px] sm:h-[19px] sm:w-[97px]',
    path: `${IMGIX_URL}/global/subscribe/Nvidia_White_Logo.png`,
  },
  {
    name: 'Amazon',
    className: 'h-[17px] w-[56px] sm:h-[20px] sm:w-[66px]',
    path: `${IMGIX_URL}/global/subscribe/Amazon_White_Logo.png`,
  },
];
